import store from "../store";

export default function waitForRefreshToken() {
	return new Promise(resolve => {
		if (!store.getters["session/refreshTokenRequestIsActive"]) {
			return store.dispatch("session/setRefreshTokenRequestActive", null, { root: true })
				.then(() => resolve(true));
		}
		const unwatch = store.watch(
			(_, getters) => getters["session/refreshTokenRequestIsActive"],
			isActive => {
				if (!isActive) {
					resolve(false);
					unwatch();
				}
			}
		);
	});
}



// WEBPACK FOOTER //
// ./src/utils/wait-for-refresh-token.js